export default "__VITE_ASSET__fc171eda__"